export default "__VITE_ASSET__CY_TH_67__"